// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__ISTkn","subHeader":"Header_subHeader__2LR6z","title":"Header_title__1hl03","subtitle":"Header_subtitle__jXxYu"};